import Vue from 'vue'
// import Toast from 'vue2-toast'
// import 'vue2-toast/lib/toast.css';

// Vue.use(Toast);
let vm = new Vue()

let showLoad = function () {
    console.warn("加载中...")
    //vm.$loading('加载中...')
}

let hideLoad = function () {
    console.warn("加载结束")
    //vm.$loading.close();
}

let toast = function (data) {
    vm.$toast(data);
}

/**
 * @lastTime  {[number]}   活动截止日期的时间戳
 * @return {[String]}   活动倒计时
 */
let fromDateQ = function (lastTime) {

    let newData = new Date().getTime();
    lastTime = lastTime - newData
    var day = Math.floor(lastTime / 86400000); // 天
    lastTime = lastTime - 86400000 * day
    var hour = Math.floor(lastTime / 3600000); //小时
    lastTime = lastTime - 3600000 * hour
    var minute = Math.floor(lastTime / 60000); //分
    lastTime = lastTime - 60000 * minute
    var second = Math.floor(lastTime / 1000); //秒

    if (day == 0 && hour == 0 && minute == 0 && second == 0) {
        for (let i = 0; i < 9999; i++) {
            clearInterval(i)
        }
    }
    return `${day}天${hour}时${minute}分${second}秒`
}

/**
 * @lastTime  {[number]}   团截止日期的时间戳
 * @return {[String]}   团倒计时
 */
let fromDateTuan = function (lastTime, type) {

    let newData = new Date().getTime();
    lastTime = lastTime - newData
    var hour = Math.floor(lastTime / 3600000); //小时
    lastTime = lastTime - 3600000 * hour
    var minute = Math.floor(lastTime / 60000); //分
    lastTime = lastTime - 60000 * minute
    var second = Math.floor(lastTime / 1000); //秒

    if (hour == 0 && minute == 0 && second == 0) {
        for (let i = 0; i < 9999; i++) {
            clearInterval(i)
        }
    }
    if (type === 'h') {
        hour = String(hour).padStart(2, 0)
        return hour
    }
    if (type === 'm') {
        minute = String(minute).padStart(2, 0)
        return minute
    }
    if (type === 's') {
        second = String(second).padStart(2, 0)
        return second
    }
}

/**
 * 
 * @param {string} name 获取url参数 
 */
let getUrlParameter = function (name) {

    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;

}


let setSto = function (name, val) {
    localStorage.setItem(name, val);
}

let getSto = function (name) {
    return localStorage.getItem(name)
}

let setStoObj = function (name, val) {
    val = JSON.stringify(val)
    localStorage.setItem(name, val);
}

let getStoObj = function (name) {
    return JSON.parse(localStorage.getItem(name))
}


let goUrl = function (url) {
    window.location = url
}
// 区分安卓IOS
let isAndroid = function () {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
        console.error('进入安卓')
        return true;
    } else if (isiOS) {
        console.error('进入iOS')
        return false;
    }
}


/**
 * 报表类型
 */
let AppReportType = {
    首页看板: 1,
    业务报表: 2,
    销售报表: 3,
    采购报表: 4,
    库存报表: 5,
    客户报表: 6,
    财务报表: 7,
    营销报表: 8
}
/**
 * 数据项类型
 */
let AppRptSubType = {
    接车台次统计 : 20001,
    施工工作量 : 20002,
    施工类型 : 20003,
    昨日接车台次统计 : 20004,
    预约到店台次统计 : 20005,
    施工进度 : 20006,
    客户车辆类型分布 : 20007,
    昨日预约到店台次 : 20008,
    营业额 : 30001,
    单日营业额 : 30002,
    单日毛利 : 30003,
    客单价 : 30004,
    商品销量排行 : 30005,
    商品销售额排行 : 30006,
    会员卡销售数量 : 30007,
    单日会员卡销售数量 : 30008,
    会员卡销售额 : 30009,
    单日会员卡销售额 : 30010,
    会员卡退卡数量及金额统计 : 30011,
    单日会员卡退卡数量及金额统计 : 30012,
    会员卡消费的营业额 : 30013,
    单日会员卡消费的营业额 : 30014,
    会员卡总销售额 : 30015,
    单日会员卡总销售额 : 30016,
    销售成本 : 30017,
    销售总毛利 : 30018,
    昨日营业额 : 30019,
    昨日客单价 : 30020,
    昨日销售成本 : 30021,
    昨日销售总毛利 : 30022,
    昨日会员卡总销售额 : 30023,
    消费用户构成 : 30024,
    销售毛利品类分布 : 30025,
    采购总货值 : 40001,
    采购件数 : 40002,
    采购商品额分布 : 40003,
    采购供应商占比 : 40004,
    采购供应商品类贡献分析 : 40005,
    昨日采购总货值 : 40006,
    昨日采购件数 : 40007,
    库存总货值 : 50001,
    入库总货值 : 50002,
    单日入库总货值 : 50003,
    出库总货值 : 50004,
    单日出库总货值 : 50005,
    昨日入库总货值 : 50006,
    昨日出库总货值 : 50007,
    商品大类库存数量 : 50008,
    商品大类库存货值 : 50009,
    客户总数 : 60001,
    新增客户总数 : 60002,
    新老客户构成 : 60003,
    老客户消费频次 : 60004,
    客户会员类型占比 : 60005,
    客户车辆行驶里程分布 : 60006,
    昨日新增客户总数 : 60007,
    客户流失率统计 : 60008,
    客户性别比例 : 60009,
    客户车辆车型数量 : 60010,
    客户属性分布 : 60011,
    客户累积消费金额阶梯分布 : 60012,
    实收款总金额 : 70001,
    实付款总金额 : 70002,
    实收款金额支付方式分布 : 70003,
    应收款总金额 : 70004,
    应付款总金额 : 70005,
    会员卡未核销权益统计 : 70006,
    会员卡卡内总余额 : 70007,
    优惠券发放总金额 : 70008,
    优惠券发放金额 : 70009,
    秒杀成交总金额 : 70010,
    秒杀成交金额 : 70011,
    拼团成交总金额 : 70012,
    拼团成交金额 : 70013,
    昨日实收款总金额 : 70014,
    昨日实付款总金额 : 70015,
    昨日优惠券发放总金额 : 70016,
    昨日秒杀成交总金额 : 70017,
    昨日拼团成交总金额 : 70018,
    优惠券发放总数量 : 80001,
    优惠券发放数量 : 80002,
    优惠券核销数量 : 80003,
    单日优惠券发放数量 : 80004,
    单日优惠券核销数量 : 80005,
    秒杀成交总单数 : 80006,
    秒杀成交数量 : 80007,
    秒杀核销数量 : 80008,
    单日秒杀成交数量 : 80009,
    单日秒杀核销数量 : 80010,
    拼团成交总单数 : 80011,
    拼团成交数量 : 80012,
    拼团核销数量 : 80013,
    单日拼团核销数量 : 80014,
    单日拼团成交数量 : 80015,
    昨日优惠券发放总数量 : 80016,
    昨日秒杀成交总单数 : 80017,
    昨日拼团成交总单数 : 80018
}


/**
 * 根据数据项类型返回1维数据的值
 * @items  {[Array]}   接口返回的数据集合
 * @subTypeName {[string]} 数据项类型名称
 * @def {[string,int]} 找不到数据时的默认值
 * @return {[string,int]} 返回数据项对应的值,如果数据项不存在则返回默认值def
 */
let getOneDimension = function (items, subTypeName, def) {
    items = items || []
    var subType = AppRptSubType[subTypeName];
    for (var i in items) {
        if (items[i].ReportSubType == subType)
            return items[i].X || def
    }
    return def;
}
/**
 * 格式化饼图的返回值
 * 根据数据项类型返回2维数据的值
 * @items  {[Array]}   接口返回的数据集合
 * @subTypeName {[string]} 数据项类型名称
 * @defX {[string,int]} 找不到数据时的默认值
 * @defY {[string,int]} 找不到数据时的默认值
 * @valueColumn {[string]} 数据值列,默认Y
 * @return {[[string,string]]} 返回数据项对应的值,如果数据项不存在则返回默认值
 */
let getTwoDimension = function (items, subTypeName, defX, defY, valueColumn) {
    items = items || []
    var subType = AppRptSubType[subTypeName];
    var rst = [["X", "Y"]];
    valueColumn = valueColumn || "Y";
    items.map(i => {
        if (i.ReportSubType == subType) {
            rst.push([i.X || defX, i[valueColumn] || defY]);
        }
    });
    if (rst.length == 1)
        rst.push([defX, defY]);
    return rst;
}
/**
 * 格式化柱状图的返回值
 * 根据数据项类型返回2维数据的值
 * @items  {[Array]}   接口返回的数据集合
 * @subTypeName {[string]} 数据项类型名称
 * @defY {[string,int]} Y轴显示得默认值
 * @defValue {[string,int]} X轴的默认值
 * @valueColumn {[string]} 数据值列,默认Y
 * @return {
    yData: [],
    Value:[],
  } 返回数据项对应的值,如果数据项不存在则返回默认值
 */
let getTwoDimensionBar = function (items, subTypeName, defY, defValue, valueColumn) {
   
    items = items || []
    var subType = AppRptSubType[subTypeName];
    valueColumn = valueColumn || "Y";
    var rst = {
        yData: [],
        Value: [],
    }
    items.map(i => {
        if (i.ReportSubType == subType) {
            rst.yData.push(i.X || defY)
            rst.Value.push(i[valueColumn] || defValue)
        }
    });
    if (rst.yData.length == 0) {
        rst.yData.push(defY)
        rst.Value.push(defValue)
    }
    console.log('data',rst,'type,',subTypeName)
    return rst;
}


/**
 * 格式化数据表格的返回值
 * 根据数据项类型返回3维数据的值
 * @items  {[Array]}   接口返回的数据集合
 * @subTypeName {[string]} 数据项类型名称
 * @defData {[string,int]} 显示得默认值
 * @valueColumn {[string]} 数据值列,默认Z
 * @return [[string,string,...]] 返回数据项对应的值,如果数据项不存在则返回默认值
 */
let getThreeDimensionTable = function (items, subTypeName, defData, valueColumn) {
    items = items || []
    var subType = AppRptSubType[subTypeName];
    valueColumn = valueColumn || "Z";
    var datas = [];
    var rows = [];
    var row = [];
    var x = [];
    var y = [];
    items.map(i => {
        if (i.ReportSubType == subType) {
            datas.push(i);
        }
    });
    if (datas.length == 0) {
        rows.push(["", defData.Y]);
        rows.push([defData.X, defData.Z]);
        return rows;
    }
    datas.map(d => {
        if (x.indexOf(d.X) == -1) {
            x.push(d.X);
        }
        if (y.indexOf(d.Y) == -1) {
            y.push(d.Y)
        }
    });
    x.sort();
    y.sort();

    //首行
    row = [""];
    y.map(i => {
        row.push(i);
    });
    rows.push(row);
    var i = 0;
    var j = 0;
    var k = 0;
    for (; i < x.length; i++) {
        row = [];
        row.push(x[i]);
        j = 0;
        for (; j < y.length; j++) {
            row.push(defData.Z)
            k = 0;
            for (; k < datas.length; k++) {
                if (datas[k].X == x[i] && datas[k].Y == y[j]) {
                    row[j + 1] = datas[k][valueColumn];
                    break;
                }
            }

        }
        rows.push(row);
    }

    return rows;
}


/**
 * 柱状图配置项
 */
let BarOption = function (data, seriesName) {
    // console.log('datadatadatadatadata------>',data)
    let dataLength = data.yData.length;
    // let endNum;
    // if(dataLength > 5){
    //     endNum = 50 / dataLength;
    //   }else{
    //     endNum = 100;
    //   }
    // endNum = 100 / dataLength;
    let dataZoomShow = dataLength > 5 ? true : false;
    // console.log(endNum,1234)
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top:'10%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                splitNumber:5,
                axisTick: {
                    show: false
                },
                data: data.yData,
                axisLabel: {
                    color: '#333',
                    interval:0,  
                    rotate:-45,
                    fontSize: 9
                },
            }
        ],
        yAxis: [
            {
                type: 'value'
                // type: 'category',
                // splitNumber:20,
                // axisTick: {
                //     show: false
                // },
                // data: data.yData
            }
        ],
        series: [
            {
                name: seriesName,
                type: 'bar',
                // barCategoryGap:'100%',
                barGap:'100%',/*多个并排柱子设置柱子之间的间距*/
                barCategoryGap :'100%',/*多个并排柱子设置柱子之间的间距*/
                label: {
                    show: true,
                    position: 'inside'
                },
                data: data.Value,
                itemStyle: {
                    normal: {
                        //每根柱子颜色设置
                        color: function (params) {
                            let colorList = [
                                "#1699E5",
                                "#F89332",
                                "#E33636",
                                "#4CC168",
                                "#FBC732",
                                "#54CFF8",
                                "#ED567D",
                                "#5A52A3",
                                "#C4C170",
                                "#70C4A4",
                            ];
                            return colorList[params.dataIndex];
                        },
                        barBorderRadius: [15, 15, 0, 0],
                    }
                },
            }
        ],
        dataZoom: [//给x轴设置滚动条
            {
                start:0,//默认为0
                // end: 100-1500/31,//默认为100
                end:computedPosition(dataLength),
                type: 'slider',
                show: dataZoomShow,
                xAxisIndex: [0],
                handleSize: 0,//滑动条的 左右2个滑动条的大小
                height: 10,//组件高度
                left: '10%', //左边的距离
                right: '5%',//右边的距离
                bottom: -5,//右边的距离
                handleColor: '#ddd',//h滑动图标的颜色
                handleStyle: {
                    borderColor: "#cacaca",
                    borderWidth: "1",
                    shadowBlur: 2,
                    background: "#ddd",
                    shadowColor: "#ddd",
                },
                // borderColor: "#000",
                fillerColor: '#5ccbb1',
                borderRadius:5,
                backgroundColor: '#33384b',//两边未选中的滑动条区域的颜色
                showDataShadow: false,//是否显示数据阴影 默认auto
                showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
                realtime:true, //是否实时更新
                filterMode: 'filter',
            },
            //下面这个属性是里面拖到
            {  
                type: 'inside',  
                show: true,  
                xAxisIndex: [0],  
                start: 0,//默认为1  
                end: 50
            },
         ],
        barWidth:20
    };
}
/**
 * 饼图配置项
 * type:判断是否 实收名录
 */
let PieOption = function (data, unit, type) {
    // data = type ? data : splitFun(data);
    data = type ? data : split5Fun(data);
    let _fontSize = data.length > 8 ? '10' : '12';
     console.log('data',data,'type,',type)
    unit = unit || '人'
    return {
        //数据
        dataset: {
            source: data
        },
        //颜色  有多少个依次添加
        color: ['#d74e67', '#0092ff', '#eba954', '#21b6b9', '#60a900', '#01949b', ' #f17677'],
        grid: {
            containLabel: true
        },
        series: [{
            tooltip: {
                trigger: 'item',
                formatter: "{b} : {c} ({d}%)"
            },
            type: 'pie',
            silent: true,
            center: ['50%', '50%'],
            radius: ['30%', '65%'], 
            avoidLabelOverlap: true,//设置 是否启用防止标签重叠策略

            label: {
                normal: {
                    formatter: '{c}' + unit,
                    textStyle: {
                        fontSize: _fontSize,
                    }
                },

            },
            labelLine: {
                normal: {
                    show: true,
                    length:0.001
                }
            },
            encode: {
                itemName: 'X',
                value: 'Y'
            }
        },
        ]
    };
}
/**
 * 折线图配置项
 */
let LineOption = function (data, ttl) {
    console.log(data.yData,'----data')
    let dataLength = data.yData.length;
    let dataZoomShow = dataLength > 5 ? true : false;
    return {
        title: {
            text: ttl
        },
        xAxis: {
            type: 'category',
            data: data.yData,
            axisLabel: {
                color: '#333',
                interval:0,  
                rotate:-45,
                fontSize: 9
            },
        },
        grid: {
            x: 50,
            y: 40,
            containLabel: false
        },
        yAxis: {
            type: 'value',
        },
        series: [{
            data: data.Value,
            type: 'line',
            symbol: 'circle',//折线点设置为实心点
            itemStyle: {
                normal: {
                    color: "#1699E5",//折线点的颜色
                    lineStyle: {
                        color: "#1699E5"//折线的颜色
                    }
                },
            },
            areaStyle: {
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0, color: '#1699E5' // 0% 处的颜色
                    }, {
                        offset: 1, color: '#E9F6FF' // 100% 处的颜色
                    }],
                    global: false // 缺省为 false
                }
            },
            label: {
                show: true
            }
        }],
        dataZoom: [{
            // show: true,
            // realtime: true,
            // y: 36,
            // height: 20,
            // start: 20,
            // end: 80,
            // bottom: -5,//右边的距离
            start:0,//默认为0
            // end: 100-1500/31,//默认为100
            end:computedPosition(dataLength),
            type: 'slider',
            show: dataZoomShow,
            xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            height: 5,//组件高度
            left: '10%', //左边的距离
            right: '5%',//右边的距离
            bottom: 20,
            handleColor: '#ddd',//h滑动图标的颜色
            handleStyle: {
                borderColor: "#cacaca",
                borderWidth: "1",
                shadowBlur: 2,
                background: "#ddd",
                shadowColor: "#ddd",
            },
            // borderColor: "#000",
            fillerColor: '#5ccbb1',
            borderRadius:5,
            showDataShadow: false,//是否显示数据阴影 默认auto  
            showDetail: false,//即拖拽时候是否显示详细数值信息 默认true  
            backgroundColor: '#33384b',//两边未选中的滑动条区域的颜色
            
        },
        //下面这个属性是里面拖到
        {  
            type: 'inside',  
            show: true,  
            xAxisIndex: [0],  
            start: 0,//默认为1  
            end: 50
        }]   
    };
}
/**
 * 文案折断
 */
function splitFun(_data){
    let splitNum = 9;
    _data.forEach(x=>{
        if((x[0].length + x[1].length)>splitNum){
            if(x[0].length>splitNum){
                x[0] = x[0].length > splitNum ? `${x[0].slice(0,splitNum)}\n${x[0].slice(splitNum)}` : `${x[0]}\n`;
            }else{
                let _num1 = x[0].length;
                console.log('x[0]',x[0],x[0].length,x[1].length)
                x[0] = `${x[0].slice(0,_num1)}\n`;
            }

        }
       
    })
    return _data;
}

function split5Fun(_data){
    _data.forEach(x=>{
        x[0] = x[0].length > 5 ? x[0].substr(0,5)+'...' : x[0]
    })
    return _data;
}

/**
 * 控制滚动条长度
 */
function computedPosition(xArraylength) {
    if(xArraylength>5){
        return Math.floor(5 / xArraylength * 100);
    }else{
        return 100;
    }
}


export default {
    fromDateQ,
    fromDateTuan,
    showLoad,
    hideLoad,
    toast,
    getUrlParameter,
    setSto,
    setStoObj,
    getSto,
    getStoObj,
    goUrl,
    isAndroid,
    AppRptSubType,
    AppReportType,
    getOneDimension,
    getTwoDimension,
    getTwoDimensionBar,
    getThreeDimensionTable,
    BarOption,
    PieOption,
    LineOption
}



//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = null
// module chunks = 